// Products
export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_ERROR = 'GET_PRODUCTS_ERROR';

// Product
export const GET_PRODUCT_REQUEST = 'GET_PRODUCT_REQUEST';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_ERROR = 'GET_PRODUCT_ERROR';

// Cart
export const ADD_TO_CART = 'ADD_TO_CART';
export const GET_CART_DATA = 'GET_CART_DATA';
export const DELETE_FROM_CART = 'DELETE_FROM_CART';

// Portal Settings
export const GET_PORTAL_SETTINGS_REQUEST = 'GET_PORTAL_SETTINGS_REQUEST';
export const GET_PORTAL_SETTINGS_SUCCESS = 'GET_PORTAL_SETTINGS_SUCCESS';
export const GET_PORTAL_SETTINGS_ERROR = 'GET_PORTAL_SETTINGS_ERROR';

// Page
export const STORE_LOCATION = 'STORE_LOCATION';
export const REMOVE_LOCATION = 'REMOVE_LOCATION';

// Braintree
export const GET_BRAINTREE_TOKEN_REQUEST = 'GET_BRAINTREE_TOKEN_REQUEST';
export const GET_BRAINTREE_TOKEN_SUCCESS = 'GET_BRAINTREE_TOKEN_SUCCESS';
export const GET_BRAINTREE_TOKEN_FAIL = 'GET_BRAINTREE_TOKEN_FAIL';

// User
export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAIL = 'CREATE_USER_FAIL';
export const GET_USER_ID_FROM_CUID_REQUEST = 'GET_USER_ID_FROM_CUID_REQUEST';
export const GET_USER_ID_FROM_CUID_SUCCESS = 'GET_USER_ID_FROM_CUID_SUCCESS';
export const GET_USER_ID_FROM_CUID_ERROR = 'GET_USER_ID_FROM_CUID_ERROR';
export const RESET_USER_ID_AND_CUID = 'RESET_USER_ID_AND_CUID';

// Transactions
export const CREATE_TRANSACTIONS_REQUEST = 'CREATE_TRANSACTIONS_REQUEST';
export const CREATE_TRANSACTIONS_SUCCESS = 'CREATE_TRANSACTIONS_SUCCESS';
export const CREATE_TRANSACTIONS_FAIL = 'CREATE_TRANSACTIONS_FAIL';
export const RUN_TRANSACTIONS_REQUEST = 'RUN_TRANSACTIONS_REQUEST';
export const RUN_TRANSACTIONS_SUCCESS = 'RUN_TRANSACTIONS_SUCCESS';
export const RUN_TRANSACTIONS_FAIL = 'RUN_TRANSACTIONS_FAIL';
export const ADD_PAYMENT_METHOD_REQUEST = 'ADD_PAYMENT_METHOD_REQUEST';
export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS';
export const ADD_PAYMENT_METHOD_FAIL = 'ADD_PAYMENT_METHOD_FAIL';
export const CLEAR_TRANSACTIONS = 'CLEAR_TRANSACTIONS';

// Error
export const CLEAR_ALL_ERRORS = 'CLEAR_ALL_ERRORS';

// Order Form
export const GET_ORDER_FORM_REQUEST = 'GET_ORDER_FORM_REQUEST';
export const GET_ORDER_FORM_SUCCESS = 'GET_ORDER_FORM_SUCCESS';
export const GET_ORDER_FORM_ERROR = 'GET_ORDER_FORM_ERROR';
export const CREATE_PAYMENT_INTENT_START = 'CREATE_PAYMENT_INTENT_START';
export const CREATE_PAYMENT_INTENT_SUCCESS = 'CREATE_PAYMENT_INTENT_SUCCESS';
export const CREATE_PAYMENT_INTENT_ERROR = 'CREATE_PAYMENT_INTENT_ERROR';

// Coupon
export const GET_COUPON_REQUEST = 'GET_COUPON_REQUEST';
export const GET_COUPON_SUCCESS = 'GET_COUPON_SUCCESS';
export const GET_COUPON_ERROR = 'GET_COUPON_ERROR';
export const CLEAR_COUPON = 'CLEAR_COUPON';
export const CLEAR_COUPON_OFF = 'CLEAR_COUPON_OFF';

// Countries
export const GET_COUNTRIES_REQUEST = 'GET_COUNTRIES_REQUEST';
export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_COUNTRIES_ERROR = 'GET_COUNTRIES_ERROR';

// Corporate Bundle
export const GET_CORPORATE_BUNDLE_REQUEST = 'GET_CORPORATE_BUNDLE_REQUEST';
export const GET_CORPORATE_BUNDLE_SUCCESS = 'GET_CORPORATE_BUNDLE_SUCCESS';
export const GET_CORPORATE_BUNDLE_ERROR = 'GET_CORPORATE_BUNDLE_ERROR';
export const GET_ORDER_FROM_CUID_REQUEST = 'GET_ORDER_FROM_CUID_REQUEST';
export const GET_ORDER_FROM_CUID_SUCCESS = 'GET_ORDER_FROM_CUID_SUCCESS';
export const GET_ORDER_FROM_CUID_ERROR = 'GET_ORDER_FROM_CUID_ERROR';
export const RUN_BUNDLE_REQUEST = 'RUN_BUNDLE_REQUEST';
export const RUN_BUNDLE_SUCCESS = 'RUN_BUNDLE_SUCCESS';
export const RUN_BUNDLE_ERROR = 'RUN_BUNDLE_ERROR';
